import type { SVGProps } from "react";
export interface ShieldOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ShieldOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ShieldOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21.042 14.45a1.124 1.124 0 0 1-2.22-.371zm-2.167-.983V7.453c0-.715-.407-1.37-1.05-1.684l-5-2.45a1.88 1.88 0 0 0-1.65 0l-1.818.89-.106.045a1.126 1.126 0 0 1-.884-2.065l1.817-.89.217-.1a4.13 4.13 0 0 1 3.415.1l5 2.45a4.13 4.13 0 0 1 2.31 3.704v6.014l-.023.498a6 6 0 0 1-.061.486l-2.22-.372q.027-.153.04-.306zM2.205 2.205a1.125 1.125 0 0 1 1.505-.078l.085.078 18 18 .078.085a1.126 1.126 0 0 1-1.584 1.583l-.085-.078-2.238-2.238c-1.426 1.362-3.036 2.42-4.116 3.059a3.62 3.62 0 0 1-3.7 0c-1.167-.69-2.94-1.86-4.436-3.37-1.378-1.39-2.668-3.221-2.824-5.349l-.015-.43V7.454c0-.832.252-1.625.696-2.29l-1.366-1.37-.078-.084a1.125 1.125 0 0 1 .078-1.506Zm2.92 11.263.01.265c.1 1.332.935 2.674 2.179 3.93 1.302 1.314 2.89 2.371 3.981 3.018l.169.085c.402.17.856.142 1.24-.085 1.012-.6 2.434-1.55 3.667-2.719L5.232 6.823c-.07.199-.107.412-.107.63z"
      />
    </svg>
  );
}
